import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { AuthToken, AuthLogin } from "../lib/MyHttp";

const Login = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [saveId, setSaveId] = useState(false);
    const [savePwd, setSavePwd] = useState(false);

    const [ID, setID] = useState("");
    const [pwd, setPwd] = useState("");

    useEffect(() => {
        loadInfo();
    }, []);

    const loadInfo = () => {
        const saveId = localStorage.getItem("saveId");
        const savePwd = localStorage.getItem("savePwd");

        if (saveId === "true") {
            setSaveId(saveId);
            setID(localStorage.getItem("inputId"));
        }
        if (savePwd === "true") {
            setSavePwd(savePwd);
            setPwd(localStorage.getItem("inputPwd"));
        }
    };

    const clickLogin = () => {
        localStorage.setItem("saveId", saveId ? "true" : "false");
        localStorage.setItem("savePwd", savePwd ? "true" : "false");
        localStorage.setItem("inputId", saveId ? ID : "");
        localStorage.setItem("inputPwd", savePwd ? pwd : "");

        AuthLogin(
            ID,
            pwd,
            res => {
                window.location.href = "/";
            },
            res => {
                alert(t("아이디 및 패스워드를 확인해주세요."));
            }
        );
    };

    return (
        // 로그인
        <main className="sub-contents">
            <section className="login-wrapper">
                <div className="mobile_top_sec">
                    {/* <h2 className="logo">효심</h2> */}
                    <p className="text">
                        {t("효심의 회원 전용 서비스")} <br />
                        {t("이용을 위해 로그인 해주세요.")}
                    </p>
                </div>
                <div className="inner">
                    <h2 className="logo">{t("독거노인 건강 모니터링 시스템 효심")}</h2>
                    <p className="desc">
                        {t("무구속 | 무자각 방식 비대면 복지 솔루션")}
                        <br />
                        {t("회원 전용 서비스 이용을 위해 로그인해주세요.")}
                    </p>
                    <form>
                        <p className="row">
                            <input type="text" className="text_nor" placeholder={t("아이디")} value={ID} onChange={e => setID(e.target.value)} />
                        </p>
                        <p className="row">
                            <input type="password" className="text_nor" placeholder={t("비밀번호")} value={pwd} onChange={e => setPwd(e.target.value)} />
                        </p>
                        <div className="checks">
                            <span>
                                <input
                                    type="checkbox"
                                    id="save_id"
                                    checked={saveId}
                                    onClick={() => {
                                        setSaveId(!saveId);
                                    }}
                                />
                                <label htmlFor="save_id">{t("아이디 저장")}</label>
                            </span>
                            <span>
                                <input
                                    type="checkbox"
                                    id="save_pwd"
                                    checked={savePwd}
                                    onClick={() => {
                                        setSavePwd(!savePwd);
                                    }}
                                />
                                <label htmlFor="save_pwd">{t("비밀번호 저장")}</label>
                            </span>
                        </div>
                        <div className="btns">
                            <button type="button" className="btn_login orange" onClick={clickLogin}>
                                {t("로그인")}
                            </button>
                            <button
                                type="button"
                                onClick={() => {
                                    navigate("/join");
                                }}
                                className="btn_login"
                            >
                                {t("회원가입")}
                            </button>
                        </div>
                        <div className="link">
                            <a href="/login/id">{t("아이디 찾기")}</a>
                            <a href="/login/password">{t("비밀번호 찾기")}</a>
                        </div>
                    </form>
                </div>
            </section>
        </main>
    );
};

export default Login;
